/**
 * FilterPillsSection Component
 *
 * Displays applied filter pills with remove functionality.
 */

import React from 'react';

import { AppliedFilterPills } from '../index';
import { useMonitoringFilterActions } from '../../../contexts/MonitoringCenterContext';

/**
 * Applied filter pills section
 */
export function FilterPillsSection() {
  const filterActions = useMonitoringFilterActions();

  if (filterActions.appliedFilterPills.length === 0) {
    return null;
  }

  return (
    <AppliedFilterPills
      filters={filterActions.appliedFilterPills}
      onRemove={filterActions.onRemoveFilterPill}
    />
  );
}
